import type { BusinessTypeListItem } from '../../shell/session/domain/businessProfile';
import { OTHER_RUBRO_PICKER_CODE } from './otherRubroFlow';

/** Fallback offline / error RPC: kiosco y mercado con packs de onboarding AR. */
export const PRODUCTION_ONBOARDING_BUSINESS_TYPE_FALLBACKS: readonly BusinessTypeListItem[] = [
  {
    code: 'retail_counter',
    display_name: 'Kiosco',
    description: 'Golosinas, cigarrillos y recargas.',
    sort_order: 10,
    onboarding_pack_code: 'retail_counter_ar_v1',
    onboarding_picker_group: 'Mostrador',
  },
  {
    code: 'neighborhood_store',
    display_name: 'Mercado',
    description: 'Almacén, despensa, cosas de la casa.',
    sort_order: 20,
    onboarding_pack_code: 'neighborhood_store_ar_v1',
    onboarding_picker_group: 'Mostrador',
  },
];

function sortPickerTypes(types: BusinessTypeListItem[]): BusinessTypeListItem[] {
  const otros = types.filter((t) => t.code === OTHER_RUBRO_PICKER_CODE);
  const rest = types.filter((t) => t.code !== OTHER_RUBRO_PICKER_CODE);
  return [...rest.sort((a, b) => a.sort_order - b.sort_order || a.display_name.localeCompare(b.display_name)), ...otros];
}

function readWebDevHostname(): string | null {
  if (typeof window === 'undefined') return null;
  const location = (window as { location?: { hostname?: string } }).location;
  const host = location?.hostname;
  return typeof host === 'string' && host.length > 0 ? host : null;
}

/** True en localhost web: el RPC recibe p_include_all y lista todos los rubros activos. */
export function isOnboardingBusinessTypesFullListEnabled(): boolean {
  const host = readWebDevHostname();
  if (!host) return false;
  return host === 'localhost' || host === '127.0.0.1';
}

/** Aplica fallback local si el RPC devolvió lista vacía (offline / error). */
export function filterBusinessTypesForOnboardingPicker(
  types: BusinessTypeListItem[],
): BusinessTypeListItem[] {
  if (types.length > 0) return sortPickerTypes(types);
  return sortPickerTypes([...PRODUCTION_ONBOARDING_BUSINESS_TYPE_FALLBACKS]);
}

/** Lista inicial del picker sin depender del RPC (kiosco + mercado). */
export function getProductionOnboardingBusinessTypePickerSeed(): BusinessTypeListItem[] {
  return [...PRODUCTION_ONBOARDING_BUSINESS_TYPE_FALLBACKS];
}
